export const isPathNotToShowExpressCheckout = (path: string) =>
  [
    '/wallet-management/add-payment-method',
    '/payment-with-wallet/secondary/wallet-management/add-payment-method',
    '/add-payment-method-v2',
  ].includes(path);
